const UNKNOWN = { device: 'Sconosciuto', os: '', browser: '' };

const getBrowser = (ua) => {
    if (/Edg\//.test(ua)) return `Edge ${ua.match(/Edg\/(\d+)/)?.[1] ?? ''}`.trim();
    if (/OPR\//.test(ua)) return `Opera ${ua.match(/OPR\/(\d+)/)?.[1] ?? ''}`.trim();
    if (/Chrome\//.test(ua)) return `Chrome ${ua.match(/Chrome\/(\d+)/)?.[1] ?? ''}`.trim();
    if (/Firefox\//.test(ua)) return `Firefox ${ua.match(/Firefox\/(\d+)/)?.[1] ?? ''}`.trim();
    if (/Version\/.*Safari\//.test(ua)) return `Safari ${ua.match(/Version\/(\d+)/)?.[1] ?? ''}`.trim();
    return '';
};

const WINDOWS_VERSIONS = { '10.0': '10', '6.3': '8.1', '6.2': '8', '6.1': '7' };

const getDeviceAndOs = (ua) => {
    if (/iPhone/.test(ua)) return { device: 'iPhone', os: `iOS ${ua.match(/OS (\d+)/)?.[1] ?? ''}`.trim() };
    if (/iPad/.test(ua)) return { device: 'iPad', os: `iOS ${ua.match(/OS (\d+)/)?.[1] ?? ''}`.trim() };
    if (/Android/.test(ua)) return { device: 'Android', os: `Android ${ua.match(/Android (\d+(?:\.\d+)?)/)?.[1] ?? ''}`.trim() };
    if (/Windows NT/.test(ua)) {
        const ntVersion = ua.match(/Windows NT (\d+\.\d+)/)?.[1];
        return { device: 'Desktop', os: `Windows ${WINDOWS_VERSIONS[ntVersion] ?? ''}`.trim() };
    }
    if (/Macintosh|Mac OS X/.test(ua)) return { device: 'Mac', os: 'macOS' };
    if (/Linux/.test(ua)) return { device: 'Desktop', os: 'Linux' };
    return { device: 'Sconosciuto', os: '' };
};

export const parseUserAgent = (userAgent) => {
    if (!userAgent) return UNKNOWN;
    return { ...getDeviceAndOs(userAgent), browser: getBrowser(userAgent) };
};

export const formatDeviceInfo = (userAgent) => {
    const { device, os, browser } = parseUserAgent(userAgent);
    const parts = [device, os, browser].filter(Boolean);
    return parts.length > 0 ? parts.join(' • ') : 'Sconosciuto';
};
